<template>
  <div v-loading="loading" element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
    :style="{ height: tableWraperHeight }" :class="['l-x-table', isPage ? 'l-x-table--haspagination' : '']">
    <!-- :tooltip-config="{ theme: tooltipEffect }" -->
    <div class="l-rblock">
      <vxe-table :expand-row-keys="expandRowKeys" :default-sort="defaultSort" @checkbox-all="handleSelectAll"
        @checkbox-change="handleSelectionChange" @cell-click="handleCellClick" @cell-mouseenter="cellMouseEnter"
        @cell-mouseleave="cellMouseLeave" @cell-dblclick="handleCellDblclick" @cell-menu="handleCellMenu"
        @header-cell-click="headerClick" @header-cell-menu="headerContextmenu" @filter-change="filterChange"
        @current-change="currentChange" @resizable-change="headerDagend" @toggle-row-expand="expandChange"
        ref="learunTable" v-if="isShowTable" style="width: 100%" size="mini" :border="border" :height="tableHeight"
        :max-height="maxHeight" :min-height="minHeight" :row-class-name="rowClassName" :cell-class-name="cellClassName"
        :header-row-class-name="headerRowClassName || 'l-x-table-header-row'"
        :header-cell-class-name="headerCellClassName" :cell-style="cellStyle" :row-style="rowStyle"
        :header-cell-style="headerCellStyle" :stripe="stripe && !isTree" :row-config="{
          isHover: isRowHover,
          isCurrent: highlightCurrentRow,
          keyField: rowKey,
        }" :column-config="{ resizable: isColumnResizable, isCurrent: isColumnCurrent, isHover: isColumnHover }"
        :checkbox-config="{
          checkField: multiSelectKey,
          reserve: reserveSelection && isMultiSelect,
          checkStrictly: checkStrictly && isTree
        }" :seq-config="{ seqMethod: indexMethod }" :tooltip-config="{ theme: tooltipEffect }"
        :sort-config="{ remote: isPage }" :show-header="showHeader" :show-footer="showSummary"
        :footer-method="getSummaries" :footer-span-method="footerRowspanMethod" :span-method="spanMethod"
        :data="tableShowData" :showOverflow="showOverflow" @sort-change="sortChangeEvent" :menu-config="menuConfig"
        :tree-config="treeConfig" :scroll-y="myScrollY" :scroll-x="{ enabled: !isExpand, gt: scrollXGt }"
        :mergeCells="mergeCells">
        <!-- 拖动排序  -->
        <vxe-column align="center" :resizable="false" width="45" v-if="isSortable && !isTree">
          <template slot="header">
            <i class="el-icon-sort" />
          </template>
          <template>
            <div class="learun-table__drag-handler">
              <i class="el-icon-rank" />
            </div>
          </template>
        </vxe-column>

        <vxe-column v-if="isExpand" :fixed="isFixed ? 'left' : ''" type="expand" width="32" :resizable="false">
          <template #content="scope">
            <slot v-bind="scope" name="table_expand"></slot>
          </template>

        </vxe-column>

        <vxe-column v-if="isMultiSelect" align="center" type="checkbox" width="40" :resizable="false"></vxe-column>
        <vxe-column v-if="isShowNum && !isTree" align="center" type="seq" :title="ShowNumLabel" :width="seqWidth"
          showOverflow :resizable="false"></vxe-column>

        <template v-for="(item, index) in tableColumns">
          <vxe-column v-if="!item.children" :key="`${item.prop || ''}${index}`" v-bind="item" :title="$t(item.label)"
            :field="item.prop" :show-overflow="item.isNotAutoWrap == false ? false : 'tooltip'" :show-header-overflow="item.isNotHeaderAutoWrap == false ? false : 'tooltip'
              " :fixed="isSortable && !isTree ? '' : item.fixed" :sortable="sortable || item.sortable"
            :min-width="isColumnResizable ? 1 : item.minWidth" :tree-node="isTree && index == 0">
            <template v-slot:header="{ column }">
              <span v-if="isRequired(column.property)" style="color: red">*</span><span>{{ column.title }}</span>
            </template>
            <template v-slot="slotProps">
              <slot v-bind="slotProps" :name="item.prop">{{
                columnText(slotProps.$index, slotProps.row, item, slotProps)
              }}</slot>
            </template>
          </vxe-column>
          <x-dynamic-column v-else :columnOption="item" :columnText="columnText" :isRequired="isRequired"
            :showOverflow="'false'" :key="index" :title="$t(item.label)" :showHeaderOverflow="item.isNotHeaderAutoWrap == false ? false : 'tooltip'
              " :fixed="isSortable && !isTree ? '' : item.fixed" :sortable="sortable" :allProps="item.props"
            :colIndex="index">
            <template v-for="myProp in item.props || []" v-slot:[myProp]="scope">
              <slot v-bind="scope" :name="myProp"></slot>
            </template>
          </x-dynamic-column>
        </template>
        <slot></slot>
      </vxe-table>
    </div>
    <div v-if="isPage" class="l-x-table--pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage" :page-sizes="pageSizes || [20, 50, 100, 200, 500, 1000]"
        :page-size.sync="currentPageSize" :layout="isExpand ? pageLayout.replace('sizes,', '') : pageLayout"
        :total="pageTotal">
      </el-pagination>
    </div>
    <l-drawer :title="$t('表格列设置')" :visible.sync="columnsVisible" :showOk="true" :showClose="false"
      :append-to-body="true" :wrapperClosable="true" :modal="false" size="320px"
      @ok="handleOk" okBtnLabel="保存" @opened="columnsSettingOpened">
      <template slot="btns">
        <el-button size="mini" type="text" @click="handleToggleSelection">{{ hasSelection ? '清空' : '全选' }}</el-button>
      </template>
      <div style="height:100%;overflow:auto;">
        <el-tree ref="columnsTree" node-key="_id" show-checkbox :data="sortedTreeColumns  " @check="handleColumnsCheck"
          draggable :allow-drop="allowDrop" :allow-drag="allowDrag" @node-drag-start="handleColumnsDragStart"
          @node-drop="handleColumnsDrop">
        </el-tree>
      </div>
    </l-drawer>
  </div>
</template>
<script>
import tableUtil from "@util/tableUtil";
import xDynamicColumn from "./x-dynamic-column";

export default {
  name: "l-table",
  mixins: [tableUtil()],
  components: {
    xDynamicColumn,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    columnsType: {
      type: String,
      default: "tree",
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    maxHeight: {
      type: [String, Number],
    },
    minHeight: {
      type: [String, Number],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },

    rowClassName: [String, Function],
    cellClassName: [String, Function],
    headerRowClassName: [String, Function],
    headerCellClassName: [String, Function],

    rowStyle: [Function, Object],
    cellStyle: [Function, Object],
    headerCellStyle: [Function, Object],

    stripe: {
      type: Boolean,
      default: true,
    },

    tooltipEffect: String,

    showSummary: {
      type: Boolean,
      default: false,
    },
    sumText: {
      type: String,
      default: "合计",
    },
    summaryMethod: Function,

    isShowNum: {
      type: Boolean,
      default: true,
    },
    ShowNumLabel: {
      type: String,
      default: "#",
    },

    isMultiSelect: Boolean,
    multiSelectKey: String,
    rowKey: String,

    reserveSelection: {
      type: Boolean,
      default: true,
    },

    isExpand: {
      type: Boolean,
      default: false,
    },
    // 树形
    isTree: {
      type: Boolean,
      default: false,
    },
    idKey: {
      type: String,
    },
    pidKey: {
      type: String,
    },
    indent: {
      type: Number,
      default: 16,
    },
    lazy: Boolean,
    load: Function,
    defaultExpandAll: Boolean,
    checkStrictly: Boolean,
    expandRowKeys: {
      type: Array,
    },

    sortable: {
      type: Boolean,
      default: false,
    },
    defaultSort: Object,
    isSortable: {
      type: Boolean,
      default: false,
    },
    spanMethod: Function,

    // 分页配置
    isPage: {
      type: Boolean,
      default: false,
    },
    pageSizes: Array,
    pageTotal: {
      type: Number,
      default: 0,
    },
    tablePage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 20,
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },

    // 扩展属性
    isChild: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    lrTableName: {
      type: String,
      default: () => {
        return window.location.href;
      },
    },
    hasChildren: {
      type: String,
      default: "hasChildren",
    },

    scrollYGt: {
      type: Number,
      default: 40,
    },
    scrollXGt: {
      type: Number,
      default: 15,
    },

    borderType: {
      type: String,
    },
    isRowHover: {
      type: Boolean,
      default: true
    },
    showOverflow: {
      type: Boolean,
      default: true
    },
    isColumnCurrent: Boolean,
    isColumnHover: {
      type: Boolean,
      default: false
    },
    isColumnResizable: {
      type: Boolean,
      default: true
    },
    isNotMinWidth: Boolean,
    mergeCells: Array,
    isBigData: Boolean,
    // 是否禁用列设置（不读取接口和本地配置，使用默认列配置）
    disableColumnSetting: {
      type: Boolean,
      default: false
    },
    // 是否互斥：打开一个列设置前关闭其他 lrTable 列设置（可选）
    exclusiveColumnsSetting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columnsVisible: false,
      columnsChecks: null,
      myPageSize: 0,
      sidx: "",
      isShowTable: true,
      isReloading: false,
      dataId: this.$uuid(),
      bigDataLength: -1,
      columnsSettingData: [],
      columnsOrder: [],
      hasApiData: false,
      // 手动 tooltip DOM
      cellTooltipEl: null,
      cellTooltipText: "",
      cellTooltipHover: false,
      cellTooltipHideTimer: null,
    };
  },
  mounted() {
    // this.initTooltipCopy();
    this.setSort();
    // 如果禁用了列设置，则不读取接口和本地配置，使用默认列顺序
    if (this.disableColumnSetting) {
      this.columnsOrder = this.arrayColumns.map(item => item._id);
    } else {
      this.getColumnsSetting();
    }
  },
  computed: {
    tableHeight() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return "100%";
      }
    },
    tableWraperHeight() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return this.height;
      }
    },
    isFixed() {
      return (
        this.arrayColumns.find((item) => {
          return item.fixed || item.fixed === "left" || item.fixed === "right";
        }) != undefined && !this.isSortable
      );
    },
    hasSelection() {
      const checks = this.columnsChecks || this.defaultCheckedKeys;
      return checks && checks.length > 0;
    },
    dataSourceLength() {
      if (this.bigDataLength != -1) {
        return this.bigDataLength;
      }
      // 关键修复：添加空值检查
      if (!this.dataSource || !Array.isArray(this.dataSource)) {
        return 0;
      }
      return this.dataSource.length;
    },
    seqWidth() {
      const max = this.indexMethod({ rowIndex: this.dataSourceLength }) + "";
      let res = max.length * 10 + 20;
      if (res < 40) {
        res = 40;
      }
      return res;
    },
    border() {
      if (
        this.tableColumns.findIndex(
          (t) => t.children && t.children.length > 0
        ) != -1
      ) {
        return "full";
      } else {
        return this.borderType || false;
      }
    },
    footerColNum() {
      let i = 0;
      if (this.isShowNum) {
        i++;
      }
      if (this.isMultiSelect) {
        i++;
      }
      return i;
    },

    myScrollY() {
      if (this.isExpand) {
        return { enabled: false }
      }
      else if (this.lazy) {
        return { enabled: true }
      }
      else {
        return { gt: this.scrollYGt, enabled: true }
      }
    },

    // 树形表格
    treeConfig() {
      if (this.isTree) {
        return {
          transform: this.lazy,
          rowField: this.idKey || this.rowKey,
          parentField: this.pidKey,
          expandAll: this.defaultExpandAll,
          indent: this.indent,
          lazy: this.lazy,
          /*loadMethod:async (params)=>{
            let res = await this.load(params);
            this.$nextTick(()=>{
              let {scrollTop,scrollLeft} = this.$refs.learunTable.getScroll();
              this.$refs.learunTable.scrollTo(scrollLeft, scrollTop -1);
            })
            return res;
          },*/
          loadMethod: this.load,
          hasChildField: this.hasChildren,
          hasChild: this.hasChildren,
          expandRowKeys: this.expandRowKeys,
          reserve: true
        };


      }
      return null;
    },

    // 右键菜单
    menuConfig() {
      return {
        enabled: true,
      };
    },

    // 列数据
    arrayColumns() {
      let columns; // 属性转化适应新的表格插件

      // 列的数据结构是树形结构，方便处理需要转成数组结构
      if (this.columnsType == "tree") {
        columns = this.$toArray(this.columns);
      } else {
        columns = this.columns;
      }

      for (let col of columns) {
        if (col.fixed == true) {
          col.fixed = "left";
        }
        if (col.fixed == false) {
          col.fixed = "";
        }

        if (col.width && col.minWidth) {
          delete col.width;
        }

        if (this.isColumnResizable && col.minWidth) {
          col.width = col.minWidth
          col.minWidth = 1;
        }
        // col.width = col.minWidth
        // if (col.width && col.minWidth) {
        //   delete col.minWidth;
        // }
      }

      return columns;
    },
    treeColumns() {
      // 列的数据结构是树形结构，方便处理需要转成数组结构
      return this.$toTree(this.$deepClone(this.arrayColumns));
    },
    chooseItem() {
      // 确保 arrayColumns 是数组
      if (!this.arrayColumns || !Array.isArray(this.arrayColumns) || this.arrayColumns.length === 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }

      // 确保 columnsChecks 和 defaultCheckedKeys 是数组
      let checks = this.columnsChecks;
      if (!checks || !Array.isArray(checks)) {
        checks = this.defaultCheckedKeys;
      }
      if (!checks || !Array.isArray(checks)) {
        checks = [];
      }

      let res = this.arrayColumns.filter(t => checks.indexOf(t._id) != -1);

      if (res.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }

      // 必须对筛选出的列进行深拷贝，避免直接修改原始 arrayColumns 对象
      // 并且在此时清理 width 属性，确保 minWidth 能生效
      // res = res.map(col => {
      //   const newCol = { ...col };
      //   if (newCol.minWidth) {
      //     // 如果有 minWidth，强制删除 width，防止 vxe-table 优先使用 width
      //     delete newCol.width;
      //   }
      //   return newCol;
      // });

      // 如果所有列都没有设置 minWidth（全是固定宽度），则强制让第一列自适应
      // 这样可以避免右侧出现大片留白
      // if (!this.isNotMinWidth && res.findIndex((t) => t.minWidth) == -1) {
      //   if (res.length > 0) {
      //     res[0].minWidth = res[0].width || "1";
      //     delete res[0].width;
      //   }
      // }
      return res;
    },
    tableColumns() {
      const sortedColumns = this.chooseItem.slice().sort((a, b) => {
        const indexA = this.columnsOrder.indexOf(a._id);
        const indexB = this.columnsOrder.indexOf(b._id);
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
      return this.$toTree(sortedColumns);
    },
    defaultCheckedKeys() {
      // 如果禁用了列设置，直接返回默认列（所有未隐藏的列）
      if (this.disableColumnSetting) {
        return this.arrayColumns
          .filter((t) => t.isNotShow != true)
          .map((t) => t._id);
      }

      if (this.columnsSettingData.length > 0) {
        return this.columnsSettingData
          .map(item => item.f_EnCode || item.columnId || item._id || item.id)
          .filter(Boolean);
      }
      const table_setting_cols = window.$getStore({
        name: "table_setting_cols",
      });
      if (table_setting_cols) {
        let choiceColumns;
        if (this.loginInfo) {
          // web
          if (
            table_setting_cols[this.loginInfo.f_UserId] &&
            table_setting_cols[this.loginInfo.f_UserId][this.lrTableName]
          ) {
            choiceColumns =
              table_setting_cols[this.loginInfo.f_UserId][this.lrTableName];
          }
        } else {
          choiceColumns = table_setting_cols[this.lrTableName]; // ui
        }
        if (choiceColumns) {
          return choiceColumns;
        }
      }

      return this.arrayColumns
        .filter((t) => t.isNotShow != true)
        .map((t) => t._id);
    },

    currentPageSize: {
      get() {
        if (this.myPageSize != 0) {
          return this.myPageSize;
        }
        return this.pageSize;
      },
      set(val) {
        this.myPageSize = val;
        this.$emit("update:pageSize", val);
      },
    },
    currentPage: {
      get() {
        if (!this.$validatenull(this.tablePage)) {
          return this.tablePage;
        } else {
          return 1;
        }
      },
      set(val) {
        this.$emit("update:tablePage", val);
      },
    },

    tableShowData() {
      let res = [];
      if (this.isTree && !this.lazy) {
        if (this.isReloading) {
          return []
        }

        res = this.$toTree(
          this.dataSource,
          this.idKey || this.rowKey,
          this.pidKey,
          this.rowKey,
          this.rowKey
        );
      } else {
        res = this.dataSource;
      }
      return res;
    },

    sortedTreeColumns() {
      const sortNodes = (nodes) => {
        if (!nodes || !nodes.length) return nodes;
        // 对当前层节点按 columnsOrder 排序
        const sorted = [...nodes].sort((a, b) => {
          const indexA = this.columnsOrder.indexOf(a._id);
          const indexB = this.columnsOrder.indexOf(b._id);
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });
        // 递归排序子节点
        sorted.forEach(node => {
          if (node.children && node.children.length) {
            node.children = sortNodes(node.children);
          }
        });
        return sorted;
      };
      const tree = this.$toTree(this.$deepClone(this.arrayColumns));
      return sortNodes(tree);
    },
  },
  created() {
    window.tableData = window.tableData || {}
    window.lrtableInstances = window.lrtableInstances || [];
    window.lrtableInstances.push(this);
  },
  watch: {
    dataSource: {
      handler(newVal) {
        // 确保 dataSource 变化时，如果是 null 或 undefined，重新设置为空数组
        if (newVal === null || newVal === undefined) {
          console.warn('dataSource is null or undefined, resetting to empty array');
          this.$emit('update:dataSource', []);
        }
      },
      immediate: true,
      deep: true
    }
  },
  beforeDestroy() {
    // 从全局实例数组中移除
    if (window.lrtableInstances) {
      const index = window.lrtableInstances.indexOf(this);
      if (index > -1) {
        window.lrtableInstances.splice(index, 1);
      }
    }
    // 强制关闭并销毁抽屉
    if (this.columnsVisible) {
      this.columnsVisible = false;
    }
    if (window.lrtableInstances) {
      window.lrtableInstances = window.lrtableInstances.filter((instance) => instance !== this);
    }
    delete window.tableData[this.dataId];
    // 清理手动 tooltip
    if (this.cellTooltipHideTimer) {
      clearTimeout(this.cellTooltipHideTimer);
      this.cellTooltipHideTimer = null;
    }
    if (this.cellTooltipEl) {
      // 检查元素是否还在 DOM 中
      if (this.cellTooltipEl.parentNode && document.body.contains(this.cellTooltipEl)) {
        try {
          this.cellTooltipEl.removeEventListener("click", this._handleCellTooltipClick);
          this.cellTooltipEl.removeEventListener("mouseenter", this._handleCellTooltipEnter);
          this.cellTooltipEl.removeEventListener("mouseleave", this._handleCellTooltipLeave);
          this.cellTooltipEl.parentNode.removeChild(this.cellTooltipEl);
        } catch (e) {
          // 忽略清理错误
        }
      }
      this.cellTooltipEl = null;
    }

    // 移除可能残留的抽屉 DOM 元素
    this.$nextTick(() => {
      const drawers = document.querySelectorAll('.el-drawer__wrapper');
      drawers.forEach(drawer => {
        // 如果抽屉的父元素不是 body 或者抽屉已经不在当前组件中
        if (drawer && drawer.parentNode === document.body) {
          // 检查这个抽屉是否属于当前表格
          const drawerId = drawer.getAttribute('data-table-id');
          if (drawerId === this._uid) {
            drawer.parentNode.removeChild(drawer);
          }
        }
      });
    });
  },
  methods: {

    // 初始化tooltip复制功能
    initTooltipCopy() {
      this.$nextTick(() => {
        // 使用事件委托监听tooltip的点击
        document.addEventListener('click', this.handleTooltipClick);
      });
    },

    // 处理tooltip点击事件
    handleTooltipClick(event) {
      // 查找是否点击了tooltip元素
      const tooltipEl = event.target.closest('.vxe-table--tooltip-wrapper');
      if (tooltipEl) {
        const content = tooltipEl.querySelector('.vxe-table--tooltip-content');
        if (content) {
          const text = content.innerText || content.textContent;
          this.copyToClipboard(text);
        }
      }
    },

    // 手动 tooltip 展示
    showCellTooltip(row, column, $event) {
      if (!column) return;
      const prop = column.property;
      if (!prop || prop == "operate") {
        this.hideCellTooltip();
        return;
      }

      // 检查当前 tooltip 元素是否还在 DOM 中，如果不在则重置引用
      if (this.cellTooltipEl && !document.body.contains(this.cellTooltipEl)) {
        this.cellTooltipEl = null;
      }

      // 清理不属于当前实例的 tooltip 元素（防止快速切换页面时遗留）
      const existingTooltips = document.querySelectorAll('.learun-table__manual-tooltip');
      existingTooltips.forEach(el => {
        if (el !== this.cellTooltipEl && el.parentNode) {
          el.parentNode.removeChild(el);
        }
      });

      const cellValue = prop ? row[prop] : "";

      // 优先取已渲染的单元格文本（支持字典/格式化后的显示值）
      const getDomText = () => {
        const el = ($event && ($event.currentTarget || $event.target)) || null;
        if (!el) return "";
        const normalize = (val) => {
          return (val || "")
            .split("\n")
            .map((t) => t.trim())
            .filter(Boolean)[0] || "";
        };
        // 针对单元格节点
        const cellEl = el.classList && el.classList.contains("vxe-cell")
          ? el
          : (el.querySelector ? el.querySelector(".vxe-cell") : null);
        // 先取常见的展示节点，避免 select 下拉的所有选项文本
        const pickSelectors = [
          ".cell--label",
          ".vxe-cell--label",
          ".el-select .el-input__inner",
          ".el-select .el-select__selected-item",
          ".el-select__tags-text",
          ".el-select .el-select__placeholder",
          ".el-select .el-tag .el-select__tags-text",
          ".el-select-dropdown__item.selected"
        ];
        if (cellEl) {
          for (let sel of pickSelectors) {
            const node = cellEl.querySelector(sel);
            if (node) {
              const txt = normalize(node.innerText || node.textContent);
              if (txt) return txt;
            }
          }
          // 再取单元格自身首行文本
          const cellTxt = normalize(cellEl.innerText || cellEl.textContent);
          if (cellTxt) return cellTxt;
        }

        // 最后取事件节点文本
        const txt = normalize(el.innerText || el.textContent);
        if (txt) return txt;
        return "";
      };

      let displayText = getDomText();

      // 若 DOM 为空，再尝试列 formatter
      if (!displayText && typeof column.formatter === "function") {
        try {
          const formatted = column.formatter({
            cellValue: cellValue,
            row,
            column,
          });
          if (formatted !== undefined && formatted !== null) {
            displayText = String(formatted);
          }
        } catch (e) { }
      }

      // 最后兜底原始值
      if (!displayText) {
        displayText =
          cellValue === undefined || cellValue === null ? "" : String(cellValue);
      }

      if (!displayText) {
        this.hideCellTooltip();
        return;
      }

      // 创建节点（如果不存在或不在 DOM 中，则创建）
      if (!this.cellTooltipEl || !document.body.contains(this.cellTooltipEl)) {
        // 如果元素存在但不在 DOM 中，先清理事件监听器
        if (this.cellTooltipEl && !document.body.contains(this.cellTooltipEl)) {
          try {
            this.cellTooltipEl.removeEventListener("click", this._handleCellTooltipClick);
            this.cellTooltipEl.removeEventListener("mouseenter", this._handleCellTooltipEnter);
            this.cellTooltipEl.removeEventListener("mouseleave", this._handleCellTooltipLeave);
          } catch (e) {
            // 忽略清理错误
          }
        }

        this.cellTooltipEl = document.createElement("div");
        this.cellTooltipEl.className = "learun-table__manual-tooltip";
        const style = this.cellTooltipEl.style;
        style.position = "fixed";
        style.maxWidth = "460px";
        style.padding = "8px 12px";
        style.background = "rgba(0,0,0,0.78)";
        style.color = "#fff";
        style.fontSize = "12px";
        style.borderRadius = "4px";
        style.boxShadow = "0 2px 8px rgba(0,0,0,0.25)";
        style.zIndex = "9999999";
        style.wordBreak = "break-all";
        style.pointerEvents = "auto";
        style.cursor = "pointer";
        document.body.appendChild(this.cellTooltipEl);

        // 点击 tooltip 复制内容
        this._handleCellTooltipClick = () => {
          if (this.cellTooltipText) {
            this.copyToClipboard(this.cellTooltipText);
          }
        };
        this._handleCellTooltipEnter = () => {
          this.cellTooltipHover = true;
          if (this.cellTooltipHideTimer) {
            clearTimeout(this.cellTooltipHideTimer);
            this.cellTooltipHideTimer = null;
          }
        };
        this._handleCellTooltipLeave = () => {
          this.cellTooltipHover = false;
          this.hideCellTooltip();
        };
        this.cellTooltipEl.addEventListener("click", this._handleCellTooltipClick);
        this.cellTooltipEl.addEventListener("mouseenter", this._handleCellTooltipEnter);
        this.cellTooltipEl.addEventListener("mouseleave", this._handleCellTooltipLeave);
      }

      this.cellTooltipEl.innerText = displayText;
      this.cellTooltipText = displayText;
      this.cellTooltipHover = false;
      if (this.cellTooltipHideTimer) {
        clearTimeout(this.cellTooltipHideTimer);
        this.cellTooltipHideTimer = null;
      }

      // 定位：优先显示在目标上方居中，若超出则向下
      const rect = $event && $event.target && $event.target.getBoundingClientRect
        ? $event.target.getBoundingClientRect()
        : null;
      if (rect) {
        const gap = 0; // 与单元格保持一定距离
        const tooltip = this.cellTooltipEl;

        // 先让 tooltip 可测量尺寸再定位，避免首次出现左上角
        tooltip.style.visibility = "hidden";
        tooltip.style.display = "block";
        const width = tooltip.offsetWidth || 260;
        const height = tooltip.offsetHeight || 32;
        let left = rect.left + rect.width / 2 - width / 2;
        let top = rect.top - height - gap;

        if (left + width > window.innerWidth - gap) {
          left = window.innerWidth - width - gap;
        }
        if (left < gap) {
          left = gap;
        }
        if (top < gap) {
          top = rect.bottom + gap;
        }

        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
        tooltip.style.visibility = "visible";
        tooltip.style.display = "block";
        tooltip.style.opacity = "1";
      }
    },

    hideCellTooltip() {
      if (this.cellTooltipHover) {
        return;
      }
      if (this.cellTooltipHideTimer) {
        clearTimeout(this.cellTooltipHideTimer);
      }
      this.cellTooltipHideTimer = setTimeout(() => {
        // 检查元素是否还在 DOM 中
        if (this.cellTooltipEl && document.body.contains(this.cellTooltipEl)) {
          this.cellTooltipEl.style.display = "none";
        } else if (this.cellTooltipEl) {
          // 如果元素不在 DOM 中，重置引用
          this.cellTooltipEl = null;
        }
        this.cellTooltipText = "";
        this.cellTooltipHideTimer = null;
      }, 150);
    },

    // 复制到剪贴板
    copyToClipboard(text) {
      if (!text) return;
      const content = String(text);

      const showSuccess = () => {
        this.$message({
          type: "success",
          message: this.$t("复制成功"),
          duration: 1500,
        });
      };

      const showError = () => {
        this.$message({
          type: "error",
          message: this.$t("复制失败"),
          duration: 1500,
        });
      };

      // 优先使用 Clipboard API（需浏览器支持且在安全环境）
      // try {
      //   if (
      //     typeof navigator !== "undefined" &&
      //     navigator.clipboard &&
      //     typeof navigator.clipboard.writeText === "function"
      //   ) {
      //     navigator.clipboard
      //       .writeText(content)
      //       .then(() => {
      //         showSuccess();
      //       })
      //       .catch(() => {
      //         // 降级到 execCommand
      //         this._fallbackCopy(content, showSuccess, showError);
      //       });
      //     return;
      //   }
      // } catch (e) {
      //   // 忽略，走降级逻辑
      // }

      // 不支持 Clipboard API 时，使用 execCommand 降级
      this._fallbackCopy(content, showSuccess, showError);
    },

    // 传统方式复制文本（降级方案）
    _fallbackCopy(text, onSuccess, onError) {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (ok) {
          onSuccess && onSuccess();
        } else {
          onError && onError();
        }
      } catch (e) {
        onError && onError();
      }
    },

    getDataSource() {
      let data = window.tableData[this.dataId];
      if (data) {
        data;
      } else {
        return this.dataSource || [];
      }
    },
    setDataSource(data) {
      this.bigDataLength = data.length;
      window.tableData[this.dataId] = data;
    },
    async getColumnsSetting() {
      // 如果禁用了列设置，直接返回，不读取接口配置
      if (this.disableColumnSetting) {
        this.hasApiData = false;
        this.columnsChecks = null;
        this.columnsOrder = this.arrayColumns.map(item => item._id);
        return;
      }

      const api = window.$api.system.module;
      if (!api || !this.loginInfo) {
        this.hasApiData = false;
        this.columnsChecks = null;
        this.columnsOrder = this.arrayColumns.map(item => item._id);
        return;
      }
      try {
        const params = {
          userId: this.loginInfo.f_UserId,
          moduleId: this.lrTableName,
        };
        const api = window.$api.system.module;
        const responseData = await this.$awaitWraper(api.getModuleList(params));
        let dataList = [];
        if (responseData && Array.isArray(responseData)) {
          dataList = responseData;
        }
        if (dataList.length > 0) {
          this.columnsSettingData = dataList;
          this.hasApiData = true;
          const checkedKeys = dataList
            .map(item => item.f_EnCode || item.columnId || item._id || item.id)
            .filter(Boolean);
          this.columnsChecks = checkedKeys;
          // 使用 f_SortCode 排序，字段名与保存时一致
          // 使用 f_EnCode 作为列ID，与保存时使用的字段一致
          this.columnsOrder = dataList
            .sort((a, b) => (a.f_SortCode !== undefined ? a.f_SortCode : (a.sortOrder || 999999)) - (b.f_SortCode !== undefined ? b.f_SortCode : (b.sortOrder || 999999)))
            .map(item => {
              // 优先使用 f_EnCode，因为保存时使用的是 f_EnCode
              // 如果 f_EnCode 不存在，再尝试从 arrayColumns 中找到对应的 _id
              const enCode = item.f_EnCode || item.columnId || item._id || item.id;
              if (enCode) {
                // 尝试从 arrayColumns 中找到对应的列，使用其 _id
                const column = this.arrayColumns.find(col => col._id === enCode);
                return column ? column._id : enCode;
              }
              return enCode;
            })
            .filter(Boolean);
        } else {
          this.hasApiData = false;
          this.columnsSettingData = [];
          this.columnsChecks = null;
          // 尝试从本地存储读取列顺序
          const table_setting_cols = window.$getStore({
            name: "table_setting_cols",
          });
          if (table_setting_cols) {
            let choiceColumns;
            if (this.loginInfo) {
              if (
                table_setting_cols[this.loginInfo.f_UserId] &&
                table_setting_cols[this.loginInfo.f_UserId][this.lrTableName]
              ) {
                choiceColumns =
                  table_setting_cols[this.loginInfo.f_UserId][this.lrTableName];
              }
            } else {
              choiceColumns = table_setting_cols[this.lrTableName];
            }
            // 如果本地存储中有列ID数组，使用其顺序作为 columnsOrder
            if (choiceColumns && Array.isArray(choiceColumns) && choiceColumns.length > 0) {
              // 确保本地存储中的列ID都在 arrayColumns 中存在
              const validColumnIds = choiceColumns.filter(id =>
                this.arrayColumns.some(col => col._id === id)
              );
              // 添加未在本地存储中但在 arrayColumns 中存在的列
              this.arrayColumns.forEach(col => {
                if (!validColumnIds.includes(col._id)) {
                  validColumnIds.push(col._id);
                }
              });
              this.columnsOrder = validColumnIds;
            } else {
              this.columnsOrder = this.arrayColumns.map(item => item._id);
            }
          } else {
            this.columnsOrder = this.arrayColumns.map(item => item._id);
          }
        }
      } catch (error) {
        this.hasApiData = false;
        this.columnsSettingData = [];
        this.columnsChecks = null;
        // 尝试从本地存储读取列顺序
        const table_setting_cols = window.$getStore({
          name: "table_setting_cols",
        });
        if (table_setting_cols) {
          let choiceColumns;
          if (this.loginInfo) {
            if (
              table_setting_cols[this.loginInfo.f_UserId] &&
              table_setting_cols[this.loginInfo.f_UserId][this.lrTableName]
            ) {
              choiceColumns =
                table_setting_cols[this.loginInfo.f_UserId][this.lrTableName];
            }
          } else {
            choiceColumns = table_setting_cols[this.lrTableName];
          }
          // 如果本地存储中有列ID数组，使用其顺序作为 columnsOrder
          if (choiceColumns && Array.isArray(choiceColumns) && choiceColumns.length > 0) {
            // 确保本地存储中的列ID都在 arrayColumns 中存在
            const validColumnIds = choiceColumns.filter(id =>
              this.arrayColumns.some(col => col._id === id)
            );
            // 添加未在本地存储中但在 arrayColumns 中存在的列
            this.arrayColumns.forEach(col => {
              if (!validColumnIds.includes(col._id)) {
                validColumnIds.push(col._id);
              }
            });
            this.columnsOrder = validColumnIds;
          } else {
            this.columnsOrder = this.arrayColumns.map(item => item._id);
          }
        } else {
          this.columnsOrder = this.arrayColumns.map(item => item._id);
        }
      }
    },
    saveColumnsSettingLocal() {
      const table_setting_cols =
        window.$getStore({ name: "table_setting_cols" }) || {};
      const orderedColumnIds = this.chooseItem
        .slice()
        .sort((a, b) => {
          const indexA = this.columnsOrder.indexOf(a._id);
          const indexB = this.columnsOrder.indexOf(b._id);
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        })
        .filter((t) => t._id)
        .map((t) => t._id);
      if (orderedColumnIds.length === 0) {
        return true;
      }
      if (this.loginInfo) {
        table_setting_cols[this.loginInfo.f_UserId] =
          table_setting_cols[this.loginInfo.f_UserId] || {};
        table_setting_cols[this.loginInfo.f_UserId][this.lrTableName] =
          orderedColumnIds;
      } else {
        table_setting_cols[this.lrTableName] = orderedColumnIds;
      }
      window.$setStore({
        name: "table_setting_cols",
        content: table_setting_cols,
      });
      return true;
    },
    async saveColumnsSetting() {
      const api = window.$api.system.module;
      if (!api || !this.loginInfo) {
        return false;
      }
      try {
        const isExplicitEmpty = Array.isArray(this.columnsChecks) && this.columnsChecks.length === 0;
        const defaultChecked = this.defaultCheckedKeys || [];
        // const checkedKeys =
        //   Array.isArray(this.columnsChecks) && this.columnsChecks.length > 0
        //     ? this.columnsChecks
        //     : defaultChecked;
        // const settingData = this.arrayColumns
        //   .filter((column) => checkedKeys.includes(column._id))
        //   .map((column, index) => {
        //     const sortOrder = this.columnsOrder.indexOf(column._id);
        //     return {
        //       f_EnCode: column.prop || column._id,
        //       f_SortCode: sortOrder >= 0 ? sortOrder : index,
        //       f_CreateDate: new Date().toISOString(),
        //     };
        //   });
        // const requestBody = {
        //   list: settingData  // 将列设置数组作为 columns 属性
        // };
        // console.log(requestBody, 'requestBody');

        // const api = window.$api.system.module;
        const checkedKeys = isExplicitEmpty
          ? []
          : (Array.isArray(this.columnsChecks) && this.columnsChecks.length > 0
            ? this.columnsChecks
            : defaultChecked);
        let settingData = isExplicitEmpty
          ? []
          : this.arrayColumns
            .filter((column) => checkedKeys.includes(column._id))
            .map((column, index) => {
              const sortOrder = this.columnsOrder.indexOf(column._id);
              return {
                f_EnCode: column._id,
                f_SortCode: sortOrder >= 0 ? sortOrder : index,
                f_CreateDate: new Date().toISOString(),
              };
            });
        settingData = settingData.sort((a, b) => a.f_SortCode - b.f_SortCode);
        const requestBody = { list: settingData };
        const responseData = await this.$awaitWraper(
          api.setModuleList(this.loginInfo.f_UserId, this.lrTableName, requestBody)
        );
        return responseData;
      } catch (error) {
        console.error("保存列设置失败:", error);
        console.error("错误详情:", {
          message: error.message,
          stack: error.stack,
        });
        return false;
      }
    },
    // 事件
    handleSelectionChange({
      checked,
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      this.$emit("select", {
        checked,
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    handleSelectAll({ checked, $event }) {
      this.$emit("selectAll", { checked, $event });
    },
    handleCellClick({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      triggerRadio,
      triggerCheckbox,
      triggerTreeNode,
      triggerExpandNode,
      $event,
    }) {
      this.$emit("rowClick", { row, column, $event });
      this.$emit("cellClick", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        triggerRadio,
        triggerCheckbox,
        triggerTreeNode,
        triggerExpandNode,
        $event,
      });
    },
    handleCellDblclick({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      this.$emit("rowDblclick", { row, column, $event });
      this.$emit("cellDblclick", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    handleCellMenu({ row, column, $event }) {
      this.$emit("rowContextmenu", { row, column, $event });
    },
    cellMouseEnter({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      // 手动展示 tooltip，显示当前单元格内容
      this.showCellTooltip(row, column, $event);
      // 当单元格 hover 进入时会触发该事件
      this.$emit("cellMouseEnter", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    cellMouseLeave({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      // 当单元格 hover 退出时会触发该事件
      this.$emit("cellMouseLeave", {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
      this.hideCellTooltip();
    },
    headerClick({
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      triggerResizable,
      triggerSort,
      triggerFilter,
      $event,
    }) {
      this.$emit("headerClick", {
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        triggerResizable,
        triggerSort,
        triggerFilter,
        $event,
      });
    },
    headerContextmenu({ type, column, columnIndex, $event }) {
      this.$emit("headerContextmenu", { type, column, columnIndex, $event });
    },
    filterChange({ column, property, values, datas, filterList, $event }) {
      this.$emit("filterChange", {
        column,
        property,
        values,
        datas,
        filterList,
        $event,
      });
    },
    currentChange({
      newValue,
      oldValue,
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      // 当表格的当前行发生变化的时候会触发该事件，如果要高亮当前行，请打开表格的 highlight-current-row 属性
      this.$emit("currentChange", {
        newValue,
        oldValue,
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    headerDagend({ $rowIndex, column, columnIndex, $columnIndex, $event }) {
      // 当拖动表头改变了列的宽度的时候会触发该事件
      this.$emit("headerDagend", {
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    expandChange({
      expanded,
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      $event,
    }) {
      this.$emit("expandChange", {
        expanded,
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex,
        $event,
      });
    },
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.$emit("loadPageData", {
        rows: val,
        page: this.currentPage,
        sidx: this.pageSidx,
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("loadPageData", {
        rows: this.currentPageSize,
        page: val,
        sidx: this.pageSidx,
      });
    },
    sortChangeEvent({ sortList }) {
      if (this.isPage) {
        const pageSidx = sortList
          .map((item) => `${item.property} ${item.order}`)
          .join(", ");
        this.pageSidx = pageSidx;
        this.$emit("loadPageData", {
          rows: this.currentPageSize,
          page: this.currentPage,
          sidx: pageSidx,
        });
      }
    },


    // 方法
    reset() {
      this.clearSelection();
    },
    clearSelection() {
      this.$refs.learunTable.clearCheckboxRow();
      if (this.reserveSelection && this.isMultiSelect) {
        this.$refs.learunTable.clearCheckboxReserve();
      }
    },
    toggleRowSelection(rows, selected) {
      this.$refs.learunTable.setCheckboxRow(rows, selected);
    },
    getSelected(isFull) {
      let res = this.$refs.learunTable.getCheckboxRecords();
      if (isFull) {
        let reserveRecords = this.$refs.learunTable.getCheckboxReserveRecords();
        res.push(...reserveRecords);
      }


      if (this.isTree) {
        res = this.$deepClone(res);
        for (let row of res) {
          delete row.children;
        }
      }
      return res;
    },
    loadData(data) {
      this.setDataSource(data);
      return this.$refs.learunTable.reloadData(data);
    },
    reLoadData() {
      this.isReloading = true;
      this.$nextTick(() => {
        this.isReloading = false;
      });
    },
    doLayout() {
      this.isShowTable = false;
      this.$nextTick(() => {
        this.isShowTable = true;
      });
    },
    clearCurrentColumn() {
      return this.$refs.learunTable.clearCurrentColumn();
    },



    // 内部方法
    indexMethod({ rowIndex }) {
      if (this.isPage) {
        return (this.currentPage - 1) * this.currentPageSize + rowIndex + 1;
      } else {
        return rowIndex + 1;
      }
    },


    // 行排序(暂时不支持树形结构)
    setSort() {
      const callback = () => {
        const el = this.$refs.learunTable.$el.querySelectorAll(
          ".vxe-table--body-wrapper > table > tbody"
        )[0];

        this.dragSortable = window.Sortable.create(el, {
          ghostClass: "learun-table__sortable",
          handle: ".learun-table__drag-handler",
          onEnd: (evt) => {
            const oldindex = evt.oldIndex;
            const newindex = evt.newIndex;
            let dataSource = this.getDataSource();
            const targetRow = dataSource.splice(oldindex, 1)[0];
            dataSource.splice(newindex, 0, targetRow);
            this.$emit(
              "sortable-change",
              oldindex,
              newindex,
              targetRow,
              dataSource
            );
          },
        });
      };
      if (this.isSortable && !this.isTree) {
        this.$nextTick(() => {
          callback();
        });
      }
    },

    // 表尾部 统计
    getSummaries(param) {
      if (this.summaryMethod) {
        return this.summaryMethod(param);
      }
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.sumText;
          return;
        }

        const myColumn = this.arrayColumns.find(
          (t) => t.prop == column.property
        );

        if (myColumn && myColumn.isSummary) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            sums[index] = "";
          }
        } else {
          sums[index] = "";
        }
      });
      return [sums];
    },
    footerRowspanMethod(params) {
      const { _rowIndex, _columnIndex } = params;
      if (_rowIndex === 0) {
        if (_columnIndex === 0) {
          return { rowspan: 1, colspan: this.footerColNum };
        } else if (_columnIndex < this.footerColNum) {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },

    // 校验
    isRequired(property) {
      let myColumn = this.arrayColumns.find((t) => t.prop == property);
      if (!myColumn) {
        return false;
      }
      return myColumn.required;
    },
    validate() {
      let res = true;
      let dataSource = this.getDataSource();
      // 确保 dataSource 是数组
      if (!dataSource || !Array.isArray(dataSource)) {
        dataSource = [];
      }
      if (this.required) {
        if (dataSource.length == 0) {
          this.$message({
            type: "error",
            message: this.$t(`请添加表格数据`),
          });
          return false;
        }
      }
      try {
        dataSource.forEach((row, index) => {
          this.arrayColumns.forEach((col) => {
            if (!col.isHidden) {
              if (col.required && this.$validatenull(row[col.prop])) {
                this.$message({
                  type: "error",
                  message: this.$t(`请输入第${index + 1}行-${col.label}`),
                });
                res = false;
                throw new Error();
              }

              if (col.patterns && col.patterns.length > 0) {
                col.patterns.forEach((pattern) => {
                  if (
                    pattern.reg &&
                    !this.$validatenull(row[col.prop]) &&
                    !new RegExp(
                      pattern.reg.substring(1, pattern.reg.length - 1)
                    ).test(row[col.prop])
                  ) {
                    this.$message({
                      type: "error",
                      message: this.$t(
                        `${pattern.msg}第${index + 1}行-${col.label}`
                      ),
                    });
                    res = false;
                    throw new Error();
                  }
                });
              }
            }
          });
        });
      } catch (error) { }
      return res;
    },

    async handleOk(showLoading, hideLoading) {
      // 如果禁用了列设置，只使用本地保存（不调用接口）
      if (this.disableColumnSetting) {
        showLoading("保存数据...");
        const localSuccess = this.saveColumnsSettingLocal();
        setTimeout(() => {
          hideLoading();
          if (localSuccess) {
            this.$message.success("列设置保存成功");
            this.columnsVisible = false;
          } else {
            this.$message.error("本地保存失败");
          }
        }, 1000);
        return;
      }

      showLoading("保存数据...");
      let shouldClose = false;
      try {
        if (this.hasApiData) {
          const apiSuccess = await this.saveColumnsSetting();
          if (apiSuccess) {
            // this.saveColumnsSettingLocal();
            this.hasApiData = true;
            this.$message.success("列设置保存成功");
            shouldClose = true;
            // 保存成功后，更新 columnsSettingData 以保持数据一致性
            // 但不重新调用 getColumnsSetting()，避免重置当前已保存的 columnsOrder
            // 如果需要重新获取，可以在下次打开列设置时再获取
          } else {
            this.$message.error("列设置保存失败");
          }
        } else {
          const isExplicitEmpty = Array.isArray(this.columnsChecks) && this.columnsChecks.length === 0;
          const localSuccess = isExplicitEmpty ? true : this.saveColumnsSettingLocal();
          if (!localSuccess && !isExplicitEmpty) {
            this.$message.error("本地保存失败");
            return;
          }
          let apiSuccess = false;
          try {
            apiSuccess = await this.saveColumnsSetting();
          } catch (apiError) {
            console.error("接口保存失败:", apiError);
          }
          if (apiSuccess) {
            this.hasApiData = true;
            this.$message.success("列设置保存成功");
            shouldClose = true;
          } else {
            if (isExplicitEmpty) {
              this.$message.error("服务器保存失败");
            } else {
              this.$message.warning("本地已保存，服务器保存失败，请稍后重试");
            }
          }
        }
      } catch (error) {
        this.$message.error("列设置保存失败");
      } finally {
        hideLoading();
        if (shouldClose) {
          this.columnsVisible = false;
        }
      }
      this.getColumnsSetting();
    },
    clearColumnsSettingCache() {
      this.columnsChecks = null;
      this.columnsOrder = this.arrayColumns.map((item) => item._id);
      if (this.$refs.columnsTree && this.$refs.columnsTree.setCheckedKeys) {
        try {
          this.$refs.columnsTree.setCheckedKeys([]);
        } catch (e) {
          // ignore
        }
      }
    },
    closeColumnsSetting() {
      this.clearColumnsSettingCache();
      this.columnsVisible = false;
      if (this._openColumnsSettingTimer) {
        clearTimeout(this._openColumnsSettingTimer);
        this._openColumnsSettingTimer = null;
      }
    },
    openColumnsSetting() {
      if (this.exclusiveColumnsSetting) {
        const activeInstances = (window.lrtableInstances || []).filter(
          (instance) => instance !== this && instance.columnsVisible
        );
        if (activeInstances.length > 0) {
          activeInstances.forEach((instance) => {
            instance.closeColumnsSetting();
          });
          if (this._openColumnsSettingTimer) {
            clearTimeout(this._openColumnsSettingTimer);
          }
          this._openColumnsSettingTimer = setTimeout(() => {
            // this.clearColumnsSettingCache();
            this.columnsVisible = true;
            this._openColumnsSettingTimer = null;
          }, 300);
          return;
        }
      }

      // this.clearColumnsSettingCache();
      this.columnsVisible = true;
    },
    columnsSettingOpened() {
      let checks = this.columnsChecks || this.defaultCheckedKeys;
      checks = checks.filter(
        (t) =>
          this.arrayColumns.findIndex((t2) => t2._id == t && t2._hasChildren) ==
          -1
      );
      this.$refs.columnsTree.setCheckedKeys(checks);
      // const treeData = this.$refs.columnsTree.data;
      // this.updateColumnsOrder(treeData);
    },
    handleToggleSelection() {
      const checks = this.columnsChecks || this.defaultCheckedKeys;
      if (checks && checks.length > 0) {
        // 如果有选中（全选或部分选中），则清空
        this.$refs.columnsTree.setCheckedKeys([]);
        this.columnsChecks = [];
      } else {
        // 否则（未选），全选
        const allKeys = this.arrayColumns.map((item) => item._id);
        this.$refs.columnsTree.setCheckedKeys(allKeys);
        this.columnsChecks = allKeys;
      }
      this.doLayout();
    },
    handleColumnsCheck($node, data) {
      this.columnsChecks = data.checkedKeys.concat(data.halfCheckedKeys);
      this.doLayout();
    },
    allowDrag(node) {
      const data = node && node.data;
      return data && !data._hasChildren;
    },
    allowDrop(draggingNode, dropNode, type) {
      if (type === 'inner') return false;
      const targetData = dropNode && dropNode.data;
      if (targetData && targetData._hasChildren) return false;
      return true;
    },
    handleColumnsDragStart(draggingNode) {
      const tree = this.$refs.columnsTree;
      if (!tree) return;
      const checkedKeys = tree.getCheckedKeys ? tree.getCheckedKeys(false) : [];
      const leafCheckedKeys = tree.getCheckedKeys ? tree.getCheckedKeys(true) : [];
      const halfCheckedKeys = tree.getHalfCheckedKeys ? tree.getHalfCheckedKeys() : [];
      this._draggingState = {
        checkedKeys,
        leafCheckedKeys,
        halfCheckedKeys,
        draggingKey: draggingNode && draggingNode.key
      };
    },
    handleColumnsDrop() {
      const tree = this.$refs.columnsTree;
      if (!tree) {
        return;
      }
      const treeData = tree.data;
      this.updateColumnsOrder(treeData);

      const snap = this._draggingState || {};
      const checkedKeys = Array.isArray(snap.checkedKeys)
        ? snap.checkedKeys
        : (tree.getCheckedKeys ? tree.getCheckedKeys(false) : []);
      const leafCheckedKeys = Array.isArray(snap.leafCheckedKeys)
        ? snap.leafCheckedKeys
        : (tree.getCheckedKeys ? tree.getCheckedKeys(true) : []);
      const halfCheckedKeys = Array.isArray(snap.halfCheckedKeys)
        ? snap.halfCheckedKeys
        : (tree.getHalfCheckedKeys ? tree.getHalfCheckedKeys() : []);
      this.columnsChecks = leafCheckedKeys.slice();

      this.$nextTick(() => {
        if (tree.setCheckedKeys) {
          tree.setCheckedKeys(checkedKeys, false);
        }
        if (
          halfCheckedKeys &&
          halfCheckedKeys.length &&
          tree.store &&
          tree.store.nodesMap
        ) {
          halfCheckedKeys.forEach((key) => {
            const node = tree.store.nodesMap[key];
            if (node) {
              node.setChecked(false, false);
              node.indeterminate = true;
            }
          });
        }
        this.doLayout();
      });
      this._draggingState = null;
    },
    updateColumnsOrder(treeData) {
      const getLeafNodes = (nodes) => {
        let leafNodes = [];
        nodes.forEach((node) => {
          if (node.children && node.children.length > 0) {
            leafNodes = leafNodes.concat(getLeafNodes(node.children));
          } else {
            leafNodes.push(node);
          }
        });
        return leafNodes;
      };
      const leafNodes = getLeafNodes(treeData);
      this.columnsOrder = leafNodes.map((node) => node._id);
      this.arrayColumns.forEach((col) => {
        if (this.columnsOrder.indexOf(col._id) === -1) {
          this.columnsOrder.push(col._id);
        }
      });
    }

  },
};
</script>
<style lang="less">
@import "./index.less";

.l-drawer {
  .l-rblock {
    height: 100%;
    overflow: hidden;
  }
}
</style>
